<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-25T14:52:33+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe Template for other pages than the Landing page
@Last modified by:   tom
@Last modified time: 2018-02-08T10:24:59+01:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved

Example:

  <c-page id="career"
      :title="$t('career.header.title')"
      :jbheader="$t('career.header.subtitle')"
      :jblead="$t('career.header.lead')"
      jbcolor="success"
      sideimage="@/assets/img/career/team.jpg">
    [...]
  </c-page>

-->

<template>
  <div>
    <section>
      <b-container>
        <div id="title" class="header text-primary">
          <h1 v-html="title" />
        </div>
      </b-container>

      <b-jumbotron class="d-none d-sm-block"
                   :bg-variant="jbcolor"
                   text-variant="white"
                   border-variant="dark"
      >
        <template slot="header">
          <div class="container" v-html="jbheader" />
        </template>
        <template slot="lead" class="container">
          <div class="container" v-html="jblead" />
        </template>
      </b-jumbotron>

      <b-container>
        <b-row>
          <b-col v-if="sideimage" md="3">
            <!-- only top margin on screens > xs -->
            <div class="d-none d-sm-block mt-4" />
            <lzimg
              :src="sideimage"
              fluid
              width="600"
              height="450"
              :thumbnail="zoomModal"
              :zoom-modal="zoomModal"
            />
          </b-col>
          <b-col id="payload" :md="sideimage ? 9 : 12">
            <slot />
          </b-col>
        </b-row>
      </b-container>
    </section>
    <navbottom />
  </div>
</template>

<script>

import invokeScrollEvent from '@/lib/helpers/scrollPlugin'

export default {
  props: {
    // top title
    title: { type: String, default: '' },
    // jumbotron, hidden on xs screens (e.g. mobiles)
    jbheader: { type: String, default: '' },
    jblead: { type: String, default: '' },
    jbcolor: { type: String, default: 'info' },
    // side image to show fullwidth on mobiles
    sideimage: { type: String, default: '' },
    // side image optional as thumbnail, clickable for full screen modal
    zoomModal: { type: Boolean, default: false }
  },
  mounted: function () {
    // kick the lazy loading
    invokeScrollEvent('Mounted "_page"', 200)
  }
}

</script>

<style lang="scss" scoped>

  .header {
    margin-top: -10px;
    margin-bottom: 2em;
  }

  #payload {
    h1,h2 {
      margin-top: 1em !important;
    }
  }
  .sideimage.img-thumbnail {
    cursor: pointer;
  }
  #sideimgmodal {
    .modal-lg {
      max-width: 1200px;
    }
  }

</style>
